export default __webpack_public_path__ + "static/banner_back-4a7d442d15b80415e45addfa7874eab7.webp";